import React, { useState, useEffect } from 'react'
import { queryAxios } from '../../../components/reqAndHint'
import { Input, Spin } from 'antd'
import EditableTable from './projectEditTable'
import { useSelector } from 'react-redux'
// import moment from 'moment';
var date2Str = require('../../../utils/date2Str');
const { Search } = Input;


// 项目设定
export default function ProjectList(props) {

    const [dataSrc, setDataSrc] = useState();
    const langValue = useSelector(state => state.langList.value)

    useEffect(async () => {
        // console.log('List project effect ......', props);
        if (props ?.addedProject) {
            // console.log('refresh list after form submit');
            //addData提交表单成功,将新增的地区信息放到数组开头，刷新表格
            let newData = [...dataSrc];
            newData.unshift(props.addedProject);
            props.addedProject.停用日期 = date2Str.format(props.addedProject.停用日期, 'yyyy-MM-dd')
            newData.forEach((a, i) => a['序号'] = i + 1);
            setDataSrc(newData);
        } else {
            const data = await queryAxios('/project/list')
            let dataSrc = [...data.data.data];
            const permissionObj = {
                '通用': 'General',
                '不通用': 'Not General'
            }
            dataSrc.forEach((d, i) => {
                d['序号'] = i + 1
                d.ch_perm = d['权限']
                d.en_proj = d['捐款项目']
                d.en_perm = permissionObj[d.ch_perm]
            });
            dataSrc.forEach((e) => {
                e.停用日期 = date2Str.format(e.停用日期, 'yyyy-MM-dd')
            });
            setDataSrc([...dataSrc])
        }

    }, [props])


    useEffect(() => {

        return () => {
            // console.log('clear');
            setDataSrc([]);
        }

    }, [])


    const onSearch = async (value) => {
        // console.log('onSearch:', value);
        const data = await queryAxios('/project/list', { keyword: value });
        const permissionObj = {
            '通用': 'General',
            '不通用': 'Not General'
        }
        let dataSrc = [...data.data.data];
        dataSrc.forEach((d, i) => {
            d['序号'] = i + 1
            d.ch_perm = d['权限']
            d.en_perm = permissionObj[d.ch_perm]
            d.en_proj = d['捐款项目']
        });
        // console.log('dataSrc:', dataSrc)
        setDataSrc([...dataSrc])
    }

    const projectColumns = [
        {
            title: '序号',
            en_title: 'S/N',
            ch_title: '序号',
            dataIndex: '序号',
        },
        {
            title: '捐款项目',
            en_title: 'Donation items',
            ch_title: '捐款项目',
            dataIndex: '捐款项目',
            editable: true,
            rules: [{ required: true, message: '捐款项目不能为空' }],
        },
        {
            title: '停用日期',
            en_title: 'Date Deactivated',
            ch_title: '停用日期',
            dataIndex: '停用日期',
            editable: true,
        },
        {
            title: '权限',
            en_title: 'Permission ',
            ch_title: '权限',
            dataIndex: '权限',
            editable: true,
            render: (_, item) => {
                return langValue == 0 ? <span>{item.ch_perm}<br />{item.en_perm}</span> : (langValue == 1 ? item.ch_perm : item.en_perm)
            }
        },
        {
            title: '状态',
            en_title: 'status',
            ch_title: '状态',
            dataIndex: '状态',
            editable: true,
        },
    ];


    return (
        <div>

            {dataSrc ?
                (
                    <div className='project-list'>
                        <div className='search-bar'>
                            <Search className='search'
                                placeholder={langValue == 0 ? '输入关键词搜索Enter Keywords to Search' : (langValue == 1 ? '输入关键词搜索' : 'Enter Keywords to Search')}
                                style={{ width: 300, marginTop: 10, marginBottom: 16 }}
                                allowClear
                                onSearch={onSearch}
                            />
                        </div>

                        <EditableTable columns={projectColumns} dataSource={dataSrc} />
                    </div>
                )
                : <Spin>加载中</Spin>}

        </div>
    );

}
